const gtag = function(category, label, action = 'click') {
	window.gtag('event', action, {
		event_category: category,
		event_label: label,
		value: 1,
	});
};

export default gtag;
